import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Portfolio } from './components/Portfolio';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Testimonials } from './components/Testimonials';
import { Process } from './components/Process';
import { CTABanner } from './components/CTABanner';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-warmWhite font-sans text-charcoal selection:bg-gold/30" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <Portfolio data-id="element-5" />
        <WhyChooseUs data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Process data-id="element-8" />
        <CTABanner data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}